import { Flex } from "@shared-ui-components/Flex";
import Colors from "@src/constants/Colors";
import styled from "styled-components";
import { Button } from "@mui/material";

export const ListWrapper = styled(Flex)<{
  isDesktop: boolean;
}>`
  height: 100vh;
  max-height: ${(props) =>
    props.isDesktop ? "calc(100vh - 225px)" : "calc(100vh - 268px)"};
  width: 100%;
  overflow-y: auto;
  flex-direction: column;
  padding-bottom: 16px;
  gap: 16px;
`;

export const CustomLoadMoreButton = styled(Button)`
  &.MuiButtonBase-root {
    background: ${Colors.secondary};
    margin: 0px 16px;
    gap: 8px;
    border-radius: 8px;
    &:hover {
      background-color: ${Colors.secondary};
    }
  }
  .buttonText {
    padding: 5px 0px;
    font-family: Ringside Regular-Bold;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    text-transform: capitalize;
    color: ${Colors.white};
  }
`;
